import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/team-presence-demo-banner.webp';

const thumbHashString = 'PfiBAoAPIMQPhJaT4DwDmwgIiHiAgAc=';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 2.347457627118644;
const originalWidth = 1108;

const TeamPresenceDemoBanner = ({
  aspectRatio = calculatedAspectRatio,
  width = originalWidth,
  ...rest
}: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default TeamPresenceDemoBanner;
